/**
 * internal dependencies
 */
import { PIN_POOL_FORM, VEHICLE_POOL_FORM } from '../form-cardgroup-types';
import WarningModalControl from '../../../modal/warning-modal';

/**
 * Check if the user Pin Pool checkbox is checked.  If it is, then
 * enable the Pin Pool fields.  If it is not, then disable the Pin Pool fields.
 * 
 * @param {HTMLInputElement} pinPoolCheckBox - the checkbox element
 * 
 * @returns void 
 */
export const usePinPool = (pinPoolCheckBox: HTMLInputElement) => { 
  PIN_POOL_FORM.ppActiveWarning.classList.toggle('aafp_display-none', !pinPoolCheckBox.checked);
  //pinPoolCheckBox.checked ? PIN_POOL_FORM.ppExport.removeAttribute('disabled') : PIN_POOL_FORM.ppExport.setAttribute('disabled', 'true');
  //PIN_POOL_FORM.ppOptionalFields.forEach(field => field.classList.toggle('aafp_pin-disabled', !pinPoolCheckBox.checked));

  if ( !pinPoolCheckBox.checked && PIN_POOL_FORM.ppFieldContainer.children.length > 0 ) {
    WarningModalControl(PIN_POOL_FORM.ppModal, PIN_POOL_FORM.ppCardGroupName.value);
  }  
};

/**
 * Remove a Pin Pool Number from the pool.
 * 
 * @param {string} removeElement - the element to be removed
 * @param {string} id - the id of element to be removed
 */
export const removePinPoolNumber = (removeElement: string, id: string) => {  
  const getElement = document.querySelector(removeElement) as HTMLElement;
  const parentElement = document.querySelector(`#aafp_container-${id}`) as HTMLElement;
  
  if (getElement) {
    getElement.addEventListener('click', () => {
      parentElement.remove();
      
      if ( PIN_POOL_FORM.ppFieldContainer && PIN_POOL_FORM.ppFieldContainer.children.length === 0 ) {
        PIN_POOL_FORM.ppExport.setAttribute('disabled', 'true');
      }

      if ( VEHICLE_POOL_FORM.vpFieldContainer && VEHICLE_POOL_FORM.vpFieldContainer.children.length === 0 ) {
        VEHICLE_POOL_FORM.vpExport.setAttribute('disabled', 'true');
      }
    });
  }
};

/**
 * Check if the Pin Number already exists in the Pin Pool
 * 
 * @param {string} newField - the new field to be checked
 * 
 * @returns void
 */
// export const checkPinNumber = (newField: string) => { 
//   const currentPinNumberField = document.querySelector('.aafp_pin-pool-container-inner') as HTMLInputElement;
//   let timeout: any;

//   currentPinNumberField.addEventListener('keyup', event => {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => {
//       let input = event.target as HTMLInputElement;
//       if (input.classList.contains('pin_number')) {
//         checkForUniquePin(input);
//       }
//     }, 500);
//   }, undefined);
// } 

/**
 * Check if the Pin Number already exists in the Pin Pool
 * 
 * @param {HTMLInputElement} currentPinNumberField - the current pin number field
 * 
 * @returns void
 */
export const checkForUniquePin = ( currentPinNumberField: HTMLInputElement ) => {
  let isValid = false;
  if (currentPinNumberField.value.length >= 49) {
    currentPinNumberField.value = currentPinNumberField.value.slice(0, 49);
    currentPinNumberField.classList.add('invalid-pins');
    PIN_POOL_FORM.ppSubmitButton.setAttribute('disabled', 'true');
    PIN_POOL_FORM.ppErrorTwo.textContent = 'Pin Number cannot be greater than 49 characters';
  } else if ( currentPinNumberField.valueAsNumber < 0 ) {
    currentPinNumberField.classList.add('invalid-pins');
    PIN_POOL_FORM.ppSubmitButton.setAttribute('disabled', 'true');
    PIN_POOL_FORM.ppErrorTwo.textContent = 'Pin Number cannot be less than 0';
  } else if ( currentPinNumberField.value.length < 4 ) {
    currentPinNumberField.classList.add('invalid-pins');
    PIN_POOL_FORM.ppSubmitButton.setAttribute('disabled', 'true');
    PIN_POOL_FORM.ppErrorTwo.textContent = 'Pin Number cannot be less than 4 characters';
  } else {
    isValid = true;
    PIN_POOL_FORM.ppSubmitButton.removeAttribute('disabled');
    currentPinNumberField.classList.remove('invalid-pins');
    PIN_POOL_FORM.ppErrorTwo.textContent = '';
  }  

  if (isValid) {
    let error = document.querySelectorAll<HTMLInputElement>('.invalid-pins');
    error.forEach(err => {
      err.classList.remove('invalid-pins');
      PIN_POOL_FORM.ppError.textContent = '';
      PIN_POOL_FORM.ppSubmitButton.removeAttribute('disabled');
    });

    const pinNumbers = Array.from(document.querySelectorAll<HTMLInputElement>('[data-pin]'));

    let valueGroup = pinNumbers.filter(pin => pin.dataset.pin === currentPinNumberField.value);

    if (valueGroup.length === 0) return;
    let ele = valueGroup.reduce((acc, curr) => {
      if (acc.dataset.pin === curr.dataset.pin) {
        acc.classList.add('invalid-pins');
        curr.classList.add('invalid-pins');
        PIN_POOL_FORM.ppError.textContent = 'Pin Number already exists';
        PIN_POOL_FORM.ppSubmitButton.setAttribute('disabled', 'true');
      }
      
      return acc;
    });
  }
};